
import Aos from 'aos';
import React, { useEffect } from 'react'
const host = process.env.REACT_APP_API_SERVER
const OurApp = ({ loadingHomeAboutNineSecDataApi, HomeAboutNineSecDataApiData, HomeAboutNineSecDataApiError, }) => {

    const ourFeature = HomeAboutNineSecDataApiData?.home_section_eight_features ? JSON.parse(HomeAboutNineSecDataApiData?.home_section_eight_features) : []

    useEffect(function () {
        Aos.init({ duration: 1000 });
      }, []);
    return (
        <section className="app-wrap style1 ptb-50 bg-f app-bg-1" id="order">
            <div className="overlay op-95 cus-bg" />
            <div className="container"  data-aos="fade-up">
                <div className="row gx-5 align-items-center">
                    <div className="col-lg-6">
                        <div className="app-content">
                            <div className="content-title style3 text-left mb-30">
                                <span>
                                    <img
                                        src="/website/assets/img/secion-shape-1.png"
                                        alt="Image"
                                    />{" "}
                                    Our App{" "}
                                    <img
                                        src="/website/assets/img/secion-shape-2.png"
                                        alt="Image"
                                    />
                                </span>
                                <h2 className="text-white">{HomeAboutNineSecDataApiData?.home_section_eight_title}</h2>
                            </div>
                            <div className="pr-wrap style1">
                                <div className="pr-item">
                                    {ourFeature?.map((data, index) => (<h4>
                                        <i className="fa fa-check-square" key={index} />
                                        {data}
                                    </h4>))}


                                </div>
                            </div>
                            <div className="download-app-btn">
                                <a href="https://play.google.com/store/apps/details?id=com.seek2learn">
                                    <img
                                        src="/website/assets/img/app/google-playstore.png"
                                        alt="Image"
                                    />
                                </a>
                                <a href="https://apps.apple.com/in/app/seek2learn/id6474531717">
                                    <img
                                        src="/website/assets/img/app/apple-playstore.png"
                                        alt="Image"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="app-img">
                            {/* <img src="/website/assets/img/app/app-img-1.png" alt="Image" class="app-top-img md-none"> */}
                            <img src={`${host}${HomeAboutNineSecDataApiData?.home_section_eight_image}`} alt="Image" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OurApp